<div class="ip-breadcrumb d-none d-md-block">
  <a routerLink="">Accueil</a>
  >
  @if (previousRoute) {
    <span>
      <a [routerLink]="previousRoute.route">{{ previousRoute.name }}</a>
      <span>
        >
      </span>
    </span>
  }
  <span class="fw-bold">{{ currentRouteName }}</span>
</div>
